import { useState } from "react";
import { useAuth } from "../../../contexts/auth";
import "./RoleSelection.css";
import UserService from "../../../services/UserService";
import Loader from "../../../components/Loader/Loader";
import { MdOutlineCheck } from "react-icons/md";

const RoleSelection = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { user, storeUser, storeToken, accessToken } = useAuth();

	async function assumeRole(roleId) {
		setShowLoader(true);
		const response = await UserService.selectRole(roleId);
		setShowLoader(false);
		storeToken(response.data?.accessToken ?? accessToken)
		if (!response) {
			return;
		}
		setShowLoader(true);
		const responseUser = await UserService.getUserData();
		setShowLoader(false);
		storeUser({
			userData: {
				...responseUser.data,
				selectedRoleId: roleId,
			}
		});
	}

	return (
		<>
			{!user.userData.roles || user.userData.roles.length === 0 ? (
				<p className="edit-profile-title-details">
					Nenhum perfil disponível no momento.
				</p>
			) : (
				<>
					<p className="edit-profile-title-details">
						Selecione o perfil que deseja assumir:
					</p>
					{showLoader ? (
						<div className="loader" >
							<Loader
								styles={{
									marginTop: "0",
								}}
								width={25}
								height={25}
							/>
						</div >
					) : (
						<>
							{user.userData?.roles?.length > 0 && (
								<ul className="role-selection-list">
									{user.userData.roles?.map(role => (
										<li>
											<button type="button" className={`${user.userData.selectedRoleId === role.id ? 'selected-role' : ''}`} onClick={e => assumeRole(role.id)}>
												<span>{role.name}</span>
												{user.userData.selectedRoleId === role.id && (
													<MdOutlineCheck size={18} />
												)}
											</button>
										</li>
									))}
									<li>
										<button type="button" className={`${user.userData.selectedRoleId === null ? 'selected-role' : ''}`} onClick={e => assumeRole(null)}>
											<span>Nenhuma</span>
											{user.userData.selectedRoleId === null && (
												<MdOutlineCheck size={18} />
											)}
										</button>
									</li>
								</ul>
							)}
						</>
					)}
				</>
			)}
		</>
	)
}

export default RoleSelection;